<template>
  <form @submit.stop.prevent="addSurcharge">
    <div class="mt-5">
      <label>Surcharge Percentage</label>
      <input
          v-model="surcharge"
          type="number"
          class="form-control"
          :class="{
              'is-invalid': v$.surcharge.$error,
          }"
      />
      <p
          v-for="error of v$.surcharge.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div v-for="(error, index) in ordersErrors" :key="index" style="color: #D13704;">
      {{error.message}}
    </div>
    <div class="mt-3 align-middle">
      <b-button variant="primary" size="sm" class="py-2" disabled v-if="ordersLoading">
        <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
        Loading
      </b-button>
      <b-button :variant="button_color" size="sm" class="py-2 text-white" type="submit" v-else>
        {{ button_text }}
      </b-button>
    </div>
  </form>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import {mapGetters} from "vuex";
export default {
name: "order-surcharge-modal-component",
  setup () {
    return { v$: useVuelidate() }
  },
  props:{
    button_text: {type: String},
    button_color: {type: String},
    surchargeItem: {
      default: 0,
      type: Number
    },
  },
  data(){
    return{
      surcharge: this.surchargeItem
    }
  },
  computed: {
    ... mapGetters({
      ordersLoading: 'orders/ordersLoading',
      ordersErrors: 'orders/ordersErrors'
    }),
  },
  validations () {
    return {
      surcharge: {required},
    }
  },
  methods: {
    async addSurcharge(){
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }

      this.v$.$touch();
      this.$emit('addSurcharge', parseInt(this.surcharge))
    }
  }
}
</script>

<style scoped>

</style>
